export const GOOGLE_PUBLISHER_TAG_PAGE_CONFIG = Object.freeze({
  pps: {
    taxonomies: {
      IAB_AUDIENCE_1_1: { values: ["533"] },
      IAB_CONTENT_2_2: { values: ["390"] },
    },
  },
});

let hasAppliedGooglePublisherTagPageConfig = false;

/**
 * 应用 GPT 页面级 PPS 配置。
 * 必须在首次 enableServices/display 请求广告前调用，且只设置页面级信号，不改 slot 配置。
 */
export function applyGooglePublisherTagPageConfig() {
  if (hasAppliedGooglePublisherTagPageConfig) {
    return;
  }

  if (typeof window === "undefined" || !window.googletag || typeof window.googletag.setConfig !== "function") {
    return;
  }

  window.googletag.setConfig(GOOGLE_PUBLISHER_TAG_PAGE_CONFIG);
  hasAppliedGooglePublisherTagPageConfig = true;
}
